import React from 'react'
import styled from 'styled-components'
import { Link } from 'gatsby'

const Wrapper = styled.aside`
  margin: 1.5em auto 0;
  padding: 1em 0;
  max-width: ${props => props.theme.sizes.maxWidthCentered};
`

const AuthorBox = styled.div`
  line-height: 1.7;
  .author-image {
    width: 130px;
    height: 130px;
    margin: 0 auto;
    border-radius: 50% 50% 0 0;
    background: #85d0ff;
  }
  img {
    display: block;
  }
  .author-content {
    margin-top: -17px;
    background: ${props => props.theme.colors.pastelblue};
    padding: 1.5em 1.5em 1.4em;
    border-radius: 15px;
    color: rgba(0, 0, 0, 0.8);
    // border: solid 3px #a0dbff;
    font-size: 0.95em;
    a {
      color: ${props => props.theme.colors.highlight};
      text-decoration: none;
    }
    .btns {
      text-align: center;
      margin: 1.2em 0 0;
    }
    .btn {
      display: inline-block;
      width: 100px;
      margin: 0 6px 8px;
      background: #fff;
      color: #4fbbff;
      text-align: center;
      line-height: 35px;
      height: 35px;
      border-radius: 25px;
      transition: 0.2s;
      &.btn--tw {
        color: #fff;
        background: #4fbbff;
      }
      &:hover {
        transform: scale(1.1);
      }
    }
  }
  .author-name {
    font-weight: bold;
    font-size: 1.4em;
    text-align: center;
    margin: 0 0 10px;
  }
`

const PostAuthor = () => (
  <Wrapper>
    <AuthorBox>
      <div className="author-image">
        <img src="/images/mag-min.png" />
      </div>
      <div className="author-content">
        <div className="author-name">犬飼つな</div>
        <p>
          <a href="https://saruwakakun.com/life/recipe">
            力尽きたときのための簡単レシピ
          </a>
          の中の人。レシピ監修、グルメレポ＆レシピ記事執筆、書籍執筆などなどをしています。お仕事依頼はContactからお願いします！
        </p>
        <div className="btns">
          <a
            className="btn btn--tw webfont"
            href="https://twitter.com/inukai_tsuna"
            rel="nofollow"
          >
            Twitter
          </a>
          <Link className="btn webfont" to="/contact/">
            Contact
          </Link>
        </div>
      </div>
    </AuthorBox>
  </Wrapper>
)

export default PostAuthor
